webpackJsonp([126072307104019],{

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/treninky-1.85d20e4e.jpg";

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/treninky-2.6935513c.jpg";

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Image = function (_React$Component) {
	  _inherits(Image, _React$Component);
	
	  function Image() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Image);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      loaded: true
	    }, _this.onLoad = function () {
	      _this.setState({ loaded: true });
	    }, _this.setImage = function (el) {
	      _this.image = el;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Image.prototype.componentDidMount = function componentDidMount() {
	    if (!this.image.complete) this.setState({ loaded: false });
	  };
	
	  Image.prototype.render = function render() {
	    var style = { opacity: this.state.loaded ? '' : 0 };
	
	    return _react2.default.createElement('img', _extends({}, this.props, { style: style, onLoad: this.onLoad, ref: this.setImage }));
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	exports.default = Image;
	module.exports = exports['default'];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(57);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Image = __webpack_require__(79);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _treninky = __webpack_require__(470);
	
	var _treninky2 = _interopRequireDefault(_treninky);
	
	var _treninky3 = __webpack_require__(471);
	
	var _treninky4 = _interopRequireDefault(_treninky3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Treninky = function Treninky() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'Trainings' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Muvko - Tr\xE9ninky' }),
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Tr\xE9ninky'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-center' },
	        _react2.default.createElement(
	          'strong',
	          null,
	          '* Prvn\xED tr\xE9nink zdarma *'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'u-flexRow' },
	        _react2.default.createElement(
	          'div',
	          { className: 'u-center' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Kdy'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '\xDAter\xFD \u2663 20:00 - 21:30'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u010Ctvrtek \u2663 19:15 - 20:45'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'u-center' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Kde'
	          ),
	          _react2.default.createElement(
	            'address',
	            null,
	            'Energym Fitness Club',
	            _react2.default.createElement('br', null),
	            'P\u0159\xEDvozn\xED 937/3',
	            _react2.default.createElement('br', null),
	            'Praha 7'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'u-row' },
	      _react2.default.createElement('iframe', {
	        src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2558.729815201262!2d14.449269316473641!3d50.11006397942979!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470beb4ceb21ae9d%3A0xd344b02a79eb802e!2sEnergym!5e0!3m2!1sen!2scz!4v1520820601109',
	        frameBorder: '0',
	        style: { border: 0, width: '100%', height: '400px' },
	        allowFullScreen: true
	      })
	    ),
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Na\u0161e tr\xE9ninky jsou zam\u011B\u0159en\xE9 na celkov\xFD fyzick\xFD rozvoj formou hromadn\xE9ho cvi\u010Den\xED a kruhov\xE9ho tr\xE9ninku se zvolenou intenzitou a v\xFDb\u011Brem vhodn\xFDch cvik\u016F pro danou skupinu cvi\u010D\xEDc\xEDch. Kombinujeme funk\u010Dn\xED, silov\xFD a balan\u010Dn\xED tr\xE9nink tak, aby doch\xE1zelo k co nejvy\u0161\u0161\xEDmu zv\xFD\u0161en\xED Va\u0161\xED vytrvalosti a dynamiky, budov\xE1n\xED funk\u010Dn\xED svalov\xE9 hmoty a ztr\xE1ty t\u011Blesn\xE9ho tuku.'
	      ),
	      _react2.default.createElement(_Image2.default, { src: _treninky4.default, alt: 'Energym Fitness' }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Kruhov\xE9 tr\xE9ninky umo\u017E\u0148uj\xED t\xE9m\u011B\u0159 neomezen\xE9 mno\u017Estv\xED cvi\u010Debn\xEDch variant. Db\xE1me na to, aby tr\xE9ninky byly pestr\xE9, poka\u017Ed\xE9 jin\xE9 a nikoho tak neomrzely.'
	      ),
	      _react2.default.createElement(_Image2.default, { src: _treninky2.default, alt: 'Keep Muuuvin\'' })
	    )
	  );
	};
	
	exports.default = Treninky;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-treninky-js-b7560a46f62c1afe9e01.js